import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setManualsMonitoringArticles,
  setManualsMonitoringTitles,
  setManualsVpsArticles,
  setManualsVpsTitles,
  setVideos,
} from '@/redux/manuals/manualsSlice';

import manualsService from '@/services/manualsService';

const getVpsManuals = () => async dispatch => {
  try {
    const response = await manualsService.getManuals('vps');
    const { data } = response;

    const titles = {
      connection: data
        .filter(({ tag }) => tag === 'connection')
        .map(({ id, sys_name, title_ru, title_en }) => ({
          id,
          sys_name,
          title_ru,
          title_en,
        })),
      working: data
        .filter(({ tag }) => tag === 'working')
        .map(({ id, sys_name, title_ru, title_en }) => ({
          id,
          sys_name,
          title_ru,
          title_en,
        })),
      handbook: data
        .filter(({ tag }) => tag === 'handbook')
        .map(({ id, sys_name, title_ru, title_en }) => ({
          id,
          sys_name,
          title_ru,
          title_en,
        })),
    };

    dispatch(setManualsVpsTitles(titles));

    dispatch(
      setManualsVpsArticles(
        data.map(
          ({ id, sys_name, title_ru, title_en, entries_ru, entries_en }) => ({
            id,
            sys_name,
            title_ru,
            title_en,
            entries_ru,
            entries_en,
          }),
        ),
      ),
    );
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetVpsManuals failure',
    );
  }
};

const getMonitoringManuals = () => async dispatch => {
  try {
    const response = await manualsService.getManuals('monitoring');
    const { data } = response;

    const titles = data.map(({ id, sys_name, title_ru, title_en }) => ({
      id,
      sys_name,
      title_ru,
      title_en,
    }));

    dispatch(setManualsMonitoringTitles(titles));

    dispatch(
      setManualsMonitoringArticles(
        data.map(
          ({ id, sys_name, title_ru, title_en, entries_ru, entries_en }) => ({
            id,
            sys_name,
            title_ru,
            title_en,
            entries_ru,
            entries_en,
          }),
        ),
      ),
    );
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetMonitoringManuals failure',
    );
  }
};

const getVideos = () => async dispatch => {
  try {
    const response = await manualsService.getVideos();
    const { data } = response;

    dispatch(setVideos(data));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetVideos failure');
  }
};

export default {
  getVpsManuals,
  getMonitoringManuals,
  getVideos,
};
